import { Radar, Clock, Zap, Layers, RefreshCw } from "lucide-react";
import { formatIndianTime, formatUtcTime } from "../lib/operatorFormatters";

export default function ScannerPanel({ scanner }) {
  if (!scanner) return null;

  return (
    <div className="bg-zinc-950/90 border border-zinc-800/80 p-4 space-y-3 rounded-xl shadow-2xl backdrop-blur-md h-full flex flex-col justify-between" data-testid="scanner-panel">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-zinc-800/70 pb-2.5">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-sky-500/10 border border-sky-500/30 flex items-center justify-center text-sky-400">
            <Radar size={15} className="animate-spin" style={{ animationDuration: "6s" }} />
          </div>
          <div>
            <h3 className="text-xs uppercase tracking-wider font-bold text-zinc-100 font-mono">Market Scanner</h3>
            <p className="text-[10px] text-zinc-500 font-mono">Liquidity-ranked universe scanner</p>
          </div>
        </div>
        <span className="px-2 py-0.5 rounded text-[10px] font-mono font-bold bg-sky-950/80 text-sky-400 border border-sky-800/60 flex items-center gap-1">
          <span className="w-1.5 h-1.5 rounded-full bg-sky-400 animate-pulse" />
          ACTIVE
        </span>
      </div>

      {/* Grid Metrics */}
      <div className="grid grid-cols-2 gap-2 text-[11px] font-mono">
        <div className="bg-zinc-900/40 border border-zinc-800/60 rounded-lg p-2 flex flex-col justify-between">
          <span className="text-[10px] text-zinc-500 uppercase">Configured</span>
          <span className="text-sm font-bold text-zinc-100" data-testid="scanner-symbol-count">{scanner.symbols_configured ?? scanner.scanned_count ?? 0}</span>
        </div>

        <div className="bg-zinc-900/40 border border-zinc-800/60 rounded-lg p-2 flex flex-col justify-between">
          <span className="text-[10px] text-zinc-500 uppercase">Evaluated</span>
          <span className="text-sm font-bold text-emerald-400">{scanner.scanned_count ?? 0}</span>
        </div>

        <div className="bg-zinc-900/40 border border-zinc-800/60 rounded-lg p-2 flex flex-col justify-between">
          <span className="text-[10px] text-zinc-500 uppercase">Timeframes</span>
          <span className="text-xs font-bold text-sky-400">{scanner.timeframe_primary || "15m"} / {scanner.timeframe_trend || "1h"}</span>
        </div>

        <div className="bg-zinc-900/40 border border-zinc-800/60 rounded-lg p-2 flex flex-col justify-between">
          <span className="text-[10px] text-zinc-500 uppercase">Pass Duration</span>
          <span className="text-xs font-bold text-amber-400">{scanner.last_scan_duration_sec || 0}s</span>
        </div>
      </div>

      {/* Footer Timestamp */}
      <div className="pt-2 border-t border-zinc-800/60 flex items-center justify-between text-[10px] font-mono text-zinc-500">
        <span className="flex items-center gap-1">
          <Clock size={11} className="text-zinc-600" /> Last scan
        </span>
        <div className="flex items-center gap-1.5">
          <span className="text-amber-300 font-semibold" title={`UTC: ${formatUtcTime(scanner.last_scan_at)}`}>
            {scanner.last_scan_at ? formatIndianTime(scanner.last_scan_at) : "in progress…"}
          </span>
          {scanner.last_scan_at && (
            <span className="text-[9px] text-zinc-500 font-mono bg-zinc-900 px-1 py-0.2 rounded border border-zinc-800">
              {formatUtcTime(scanner.last_scan_at)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
